import { Autocomplete, AutocompleteRenderInputParams, CircularProgress, TextField } from '@mui/material'
import { useCallback, useState } from 'react'
import { useSearchVenuesQueryLazyQuery, Venue } from '../../graphql'

let timeout: NodeJS.Timeout

function SearchVenue({ disabled, label, error, value, onChange }: { disabled?: boolean, label?: string, error?: string, value: Venue | null, onChange?: ((event: React.SyntheticEvent<Element, Event>, value: Venue | null) => void) }) {
  const [searchVenues, { data: { searchVenues: searchResults } = { searchVenues: [] }, loading }] = useSearchVenuesQueryLazyQuery()
  const [typing, setTyping] = useState(false)
  const [hasSearched, setHasSearched] = useState(false)

  const handleSearchVenue = useCallback((q: string) => {
    setTyping(true)
    setHasSearched(true)
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      setTyping(false)
      searchVenues({ variables: { q } })
    }, 300)
  }, [searchVenues])

  return <Autocomplete
    options={searchResults}
    value={value}
    onInputChange={(e, v) => handleSearchVenue(v)}
    onChange={onChange}
    loading={loading || typing}
    loadingText="Zoeken..."
    filterOptions={(x) => x}
    noOptionsText={!hasSearched ? 'Typ om te zoeken...' : 'Geen podia gevonden'}
    getOptionLabel={(option: Venue) => option.name}
    disabled={disabled}
    isOptionEqualToValue={(option, value) => option.id === value.id}
    renderInput={(params: AutocompleteRenderInputParams) => (
      <TextField
        {...params}
        label={label || 'Selecteer een podium'}
        required
        error={Boolean(error)}
        helperText={error}
        InputProps={{
          ...params.InputProps,
          endAdornment: (
            <>
              {loading || typing ? <CircularProgress color="inherit" size={20} /> : null}
              {params.InputProps.endAdornment}
            </>
          ),
        }}
      />
    )}
  />
}

export default SearchVenue
